export default {"src":"/_next/static/media/socialInCircle.453f47b9.svg","height":100,"width":100};